"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.gameConfig = void 0;
exports.gameConfig = {
    potassiumLimit: 7,
    pickCardsTimeout: 30000,
    handCardLimit: 10,
    turnTimeout: 60000,
    playSpellDelay: 1500,
    playCreatureDelay: 300,
    attackDelay: 1000,
};
